import { connect } from 'react-redux';
import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { PanelHeader } from "components";
import { withTranslation } from 'react-i18next';
import ErrorModal from "../Components/ErrorModal"
import { loopbackService } from '../../services';
import { selectedProjectChangeListeners } from '../../components/Header/Header';
import { ClipLoader } from "react-spinners";
import SweetAlert from "react-bootstrap-sweetalert";
import commonActionCreatorHelper from '../../actions/commonActionCreatorHelper';

var QuickSightEmbedding = require("amazon-quicksight-embedding-sdk");

class StatsComponent extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      loading: true
    }

    selectedProjectChangeListeners.push( ()=>{
        window.location.reload(); 
    });

  }


  done(){

  }

  async fetchData(){

      try {

        const { t } = this.props;

            let projectId = localStorage.getItem('selectedProjectId');

            let language = "it";

            let user = JSON.parse(localStorage.getItem('user'));
            if (user){
                language = user.language;
            }
          
            //console.log('projectId = ',projectId);

            let url = await loopbackService.invoke('plant','statistics','getdashboardurl', projectId, language);

            let container = this.refs.dashboardContainer;

            const height = container.clientHeight+"px";
            const width = container.clientWidth+"px";

            if (url.error){
                this.setState({ errors: [ url.error ] });
                return;
            }

            var options = {
                url: url.embedUrl,
                container,
                parameters: {
                  projectId,
                  cabinetNameList: url.cabinetNameList,
                  language: language,
                  strSyraStatistics: t('Statistiche Syra'),
                  strCabinet: t('Quadro'),
                  strSyraState: t('Stato syra'),
                  strLightPointTotal: t('Totale punti luce'),
                  strActivePowerTotal: t('Potenza attiva tot.'),
                  strState: t('Stato'),
                  strSyraManagedList: t('Elenco Syra gestiti'),
                  strLightPointName: t('Nome punto luce'),
                  strCity: t('Città'),
                  strAddress: t('Indirizzo'),
                  strLatitude: t('Latitudine'),
                  strLongitude: t('Longitudine')
                },
                scrolling: "auto",
                height,
                width,
                loadCallback: ()=>{ this.setState({ loading: false}) }
              };

            QuickSightEmbedding.embedDashboard(options);

      } catch(error){
          this.setState({ errors: [ error ] })
      }
  }


  componentDidMount(){
    this.fetchData();
  }

  render() {

    const { t } = this.props;
    const { loading, errors } = this.state;
    let projectId = localStorage.getItem('selectedProjectId');

    return (
        <div className="full-height-no-header">
            {this.state.alert}
            <PanelHeader
            size="sm"
            />
            <div className="content full-height" >
            { errors && errors.length>0 && <ErrorModal error={errors} onClickHandler={ () => { this.setState({ errors: [] }) }} /> }

            <Row className="full-height " style={{ margin: 0, padding: 0}}>
                <Col xs={12} md={12} style={{ margin: 0, padding: 0, backgroundColor: "white"}} className="">

                      { loading && 
                          <div className="quicksight-loader" >
                            <ClipLoader
                              style={{ flex: 1}}
                              css={{ backgroundColor: "red"}}                    
                              sizeUnit={"px"}
                              size={88}
                              margin={"5px"}
                              color={'#ddd'}
                              loading={true}
                            />
                          </div>
                      }
                      <div ref="dashboardContainer" style={{ margin: 0, padding: 0, width: "100%", height: "100%"}} />
                </Col>
            </Row>
            </div>
        </div>
        );
    }        
  
}

function mapStateToProps(state) {
  const { users, authentication } = state;
  return {
    users,
    loggedinUser: authentication.user
  };
}

const Stats = withTranslation()(connect(mapStateToProps)(StatsComponent));
export default Stats;



// WEBPACK FOOTER //
// ./src/views/QuickSight/Stats.jsx